import React, { Component } from "react";
import styles from "./styles.scss";
// import { Link } from 'react-router-dom';
import CONFIG from "../../config";
import http from "../../helpers/http";
import WFirebase from "../../helpers/firebase";
import UserInfo from "../../helpers/userinfo";
import ListItem from "../../components/ListItem/ListItem";
import WBtn from "../../components/WBtn/WBtn";
import WModal from "../../components/WModal/WModal";
import WSpinner from "../../components/WSpinner/WSpinner";
import WMask from "../../components/WMask/WMask";

class BookingList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show_spinner: true,
      message: null,
      items: [],
    };
  }

  componentDidMount() {
    this.pullData();
  }

  pullData() {
    this.setState({ show_spinner: true });

    http.get(CONFIG.API_HOST + "api/v1.7/booking", {}, (state, res) => {
      this.setState({ show_spinner: false });

      const { code = 100, reason = "發生錯誤", data = {} } = res;

      if (state === false) {
        return this.setState({ message: "發生錯誤" });
      }

      if (code !== 200) {
        return this.setState({ message: reason });
      }

      const { my_booking: items = [] } = data;

      this.setState({
        items: items,
        message: items.length === 0 ? "目前沒有資料" : null,
      });
    });
  }

  showRepair(action, reason) {
    console.log(action, reason);

    console.log(window.FG);

    window.FG && window.FG.show_repair(action, reason);
  }

  onClick(title, item) {
    console.log(title, item);

    if (title === "取消預約") {
      var modal = WModal.show("取消預約", "您確認要取消這筆預約嗎？", {
        btns: ["確認", "取消"],
        callback: (title) => {
          console.log(title, modal);

          if (title === "確認") {
            if (UserInfo.houseid) {
              WFirebase.logEvent("PublicUtilities", {
                BookingCancel: UserInfo.houseid,
              });
            } else {
              UserInfo.pullData((user) => {
                WFirebase.logEvent("PublicUtilities", {
                  BookingCancel: UserInfo.houseid,
                });
              });
            }

            this.setState({ show_spinner: true });
            http.post(
              CONFIG.API_HOST + "api/v1.7/booking/cancel",
              { b_id: item.b_id, pu_id: item.b_id },
              (state, res) => {
                this.setState({ show_spinner: false });

                console.log(res);

                console.log(res.code);

                if (res.code !== 200) {
                  WModal.show("取消失敗");
                  return;
                }

                WModal.show("取消成功");

                this.pullData();
              }
            );
          }
        },
      });
    }
  }

  onModalClick(title, item) {
    if (title === "取消預約") {
      http.get(
        CONFIG.API_HOST + "api/v1.7/booking/cancel",
        { b_id: item.b_id },
        (state, res) => {
          console.log(res);

          console.log(res.code);

          if (res.code !== 200) {
            WModal.show("取消成功");
            return;
          }

          this.pullData();
        }
      );
    }
  }
  render() {
    // let list_content = [
    //   {
    //     title: "水管破裂",
    //     text: "水管破裂嚴重，持續漏水"
    //   },
    //   {
    //     title: "水管破裂",
    //     text: "水管破裂嚴重，持續漏水"
    //   },
    //   {
    //     title: "水管破裂",
    //     text: "水管破裂嚴重，持續漏水"
    //   }
    // ]
    // const list_item = list_content.map((item, index) =>
    //   <ListItem content={item} key={index}/>
    // );

    // let list_item = [
    //   {
    //     b_id : '1',
    //     pu_id : '282',
    //     name : '游泳池',
    //     desc : '20171227 14:00-15:00',
    //     action: false
    //   },
    //   {
    //     b_id : '2',
    //     pu_id : '282',
    //     name : '會議廳',
    //     desc : '20171227 14:00-15:00',
    //     action: false
    //   },
    // ]

    // b_id
    // name
    // user_name
    // point
    // cleaning_point
    // date
    // booking_date_period
    // period
    // desc

    const { items: list_item = [] } = this.state;

    return (
      <div className={styles.page_container}>
        <div className={styles.padding_container}>
          {list_item.map((item, index) => (
            <div>
              <div>
                <ListItem content={item} key={index}>
                  <WBtn
                    title="取消預約"
                    type={"sm"}
                    onClick={(title) => this.onClick(title, item)}
                  />
                </ListItem>
              </div>
            </div>
          ))}

          <WModal
            ref={"modal"}
            title="提醒"
            message="您確認要取消這筆預約嗎？"
            btns={["取消", "確認"]}
          />
        </div>
        {this.state.message && <WMask title={this.state.message} />}
        {this.state.show_spinner && (
          <WMask>
            <WSpinner />
          </WMask>
        )}
      </div>
    );
  }
}

export default BookingList;



// WEBPACK FOOTER //
// ./src/views/Facility/BookingList.js